import * as React from 'react';
import { Typography } from '@material-ui/core';

import { Root, RouteList, Upload } from '../containers';

const uploadDocumentPage: React.SFC = () => {
  return (
    <Root routeList={<RouteList />}>
      <Typography variant="h5" gutterBottom>
        条項別に抽出<br />
      </Typography>
      <Typography variant="h6" gutterBottom>
        　・重要な契約事項に記載漏れはないか？<br />
        　・契約書と約款、矛盾していないか？<br />
        <br />
        条項別に抽出比較するァイルを（最大３文書まで）アップロードしてください
      </Typography>
      <Upload />
    </Root>
  );
};

export default uploadDocumentPage;



// WEBPACK FOOTER //
// ./src/pages/upload.tsx